module.exports = __webpack_public_path__ + "img/dp1.21542ccb.png";